import { getAllActiveDining } from "@/services/dining.services";
import { createSlice } from "@reduxjs/toolkit";

export interface IDiningDetails {
  ID: number | null;
  DiningTitle: string;
  DiningTagline: string;
  DiningDescription: string;
  Timing: string;
  Seating: string;
  Cuisine: string;
  SequenceNo: string;
  Images: string;
  DiningInnerImage: any[];
  DiningSpecialities: any[];
}

export interface IDining {
  ID: number | null;
  DiningTitle: string;
  DiningTagline: string;
  DiningDescription: string;
  Timing: string;
  Seating: string;
  Cuisine: string;
  SequenceNo: string;
  Images: string;
  DiningInnerImage: any[];
  DiningSpecialities: any[];
}

export interface IDiningInitialState {
  loading: boolean;
  error: string;
  DiningDetails: any;
  DiningList: IDining[];
}

const initialState: IDiningInitialState = {
  loading: false,
  error: "",
  DiningDetails: {},
  DiningList: [],
};

const DiningSlice = createSlice({
  name: "dining",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveDining.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveDining.fulfilled, (state, action) => {
      state.loading = false;
      state.DiningList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveDining.rejected, (state, action) => {
      state.loading = false;
      state.DiningList = initialState.DiningList;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default DiningSlice.reducer;
